import { WeatherResponse } from '../types/WeatherData';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

export const fetchWeather = async (location: string): Promise<WeatherResponse> => {
  try {
    const response = await fetch(`${BASE_URL}/api/weather?location=${location}`, {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching weather: ${response.statusText}`);
    }

    const data: WeatherResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch weather data', error);
    throw error;
  }
};
